import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, Message } from 'primeng/primeng';
import { Location } from '@angular/common';
import { Subject } from 'rxjs/Rx';
import { EvsStoreService } from '../../../../../common/services/EvsStore.service';
import { PagerService } from '../../../../../common/services/Pagination.service';
import { ModalInfoService } from '../../../../../common/services/ModalInfo.service';
import { EvsAddressService } from '../../../../../common/services/EvsAddress.service';
import { StoreExcelComponent } from '../../../../../common/helper/evs/store/store.excel.component';
import { EvsUserService } from '../../../../../common/services/EvsUser.service';
import { StoreSaleService } from './services/store-sale.service';
import { ToastrService } from 'ngx-toastr';

import * as _ from 'lodash';
import { environment } from '../../../../../../environments/environment';
import * as moment from 'moment'
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';

declare var $: any;

@Component({
  selector: 'app-store-sale',
  templateUrl: './store-sale.component.html',
  styleUrls: ['./store-sale.component.css'],
  providers: [StoreSaleService],
})

export class StoreSaleComponent implements OnInit, OnDestroy {
  @ViewChild("importStoreSale") importStoreSale: ModalDirective;
  public dtOptions: any = {};
  public dtTrigger: Subject<any> = new Subject();
  @ViewChild('modalAddProduct') modalAddProduct;

  public currentPage: number = 1;

  public pager: any;
  public pageIndex: number = 1;
  public page_size: number = 10;
  public totalRow: number = 0;
  public total_data_store_point: number;

  public message: { class: string, content: string } = null;
  public msgs: Message[] = [];
  public error: string = '';
  public componentData = null;
  public routerChange: any;
  public model: any = {};
  public stores: any = [];
  public paramsQuery: any = {};
  public cities: Array<any> = [];
  public districts: Array<any> = [];
  public current_filter: any = {};
  public item_active: any = 0;
  public item_detail: any = {};

  loading_data = true;
  isSorting: any = {};
  isAdd: Boolean = false;
  isUpdate: Boolean = false;
  lat: number = 21.0286669;
  lng: number = 105.8521485;

  zoom: number = 15;
  isShowLocation: Boolean = false;
  listStaff: any = [];
  no_product = 'assets/images/no_product.png';
  no_image = "assets/images/no-image.png";
  modalRef: BsModalRef;
  private langSub: Subscription;

  constructor(private _location: Location,
    private router: Router,
    private storeService: EvsStoreService,
    private pagerService: PagerService,
    public addressService: EvsAddressService,
    private mdInfo: ModalInfoService,
    private activatedRoute: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private toastr: ToastrService,
    private userService: EvsUserService,
    private storeSaleService: StoreSaleService,
    private modalService: BsModalService,
    private translate: TranslateService
  ) {
  }

  listType = [
    { id: 1, value: 1, label: 'Điểm bán' },
    { id: 2, value: 2, label: 'Bảo hành' },
    { id: 3, value: 3, label: 'Điểm bán + Bảo hành' }
  ];
  totalItem: any = 0;
  totalStores: any = 0;
  totalActive: any = 0;
  totalHidden: any = 0;
  totalPage: any = 0;

  ngOnInit() {
    this.titleFile = this.translate.instant('PS_CHON_FILE_UPLOAD');
    $('[data-toggle="tooltip"]').tooltip();
    let that = this;
    this.current_filter.orderBy = "createdAt:desc";
    this.initSelect2();
    this.langSub = this.translate.onLangChange.subscribe(() => {
      this.initSelect2();
      if (!this.files || this.files.length === 0) {
        this.titleFile = this.translate.instant('PS_CHON_FILE_UPLOAD');
      }
    });
    $('#province').on("select2:select", function (e) {
      $(".select2-selection__rendered").removeAttr('title');
      let id = e.target.value;
      that.loadDistrictData(id);
    });
    $('#district').on("select2:select", function () {
      $(".select2-selection__rendered").removeAttr('title');
    });
    $('#inputStart').datepicker({ format: 'dd-mm-yyyy' });
    $('#inputEnd').datepicker({ format: 'dd-mm-yyyy' });
    $('.input-daterange').datepicker();
    this.getCity();
    this.getStaffList();
    this.loadData();
    this.isSorting['field'] = 'desc';
    this.isSorting['typeSort'] = 'createdAt';
    // this.clearDataForm();
    // this.setSort('created_at:desc');
    // if ($(window).width() <= 1280) {
    //     $('#item-filter').css({ 'margin-top': '5px' })
    // }
    // $(window).resize(() => {
    //     if ($(window).width() <= 1280) {
    //         $('#item-filter').css({ 'margin-top': '5px' })
    //     } else {
    //         $('#item-filter').css({ 'margin-top': '0px' })
    //     }
    // })
    // this.loadData2();
  }

  initSelect2() {
    $('#status').select2({ placeholder: "-- " + this.translate.instant('TRANG_THAI_LABEL') + " --", allowClear: true, minimumResultsForSearch: Infinity });
    let province = $('#province');
    let district = $('#district');
    let staff = $('#staff');
    province.select2({ placeholder: "-- " + this.translate.instant('TINH_THANH_PHO') + " --", allowClear: false });
    district.select2({ placeholder: "-- " + this.translate.instant('QUAN_HUYEN_LABEL') + " --", allowClear: false });
    staff.select2({ placeholder: "-- " + this.translate.instant('NGUOI_TAO') + " --", allowClear: false });
  }

  ngOnDestroy() {
    if (this.langSub) {
      this.langSub.unsubscribe();
    }
  }

  getStaffList() {
    this.userService
      .getEmployees({ desc: "id" })
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          this.listStaff = res.data.staffs;
          let listStaff: any = [];
          let master: any = res.data.master
          if (master) {
            listStaff.push({
              id: master.id,
              name: master.name
            });
          }
          for (let i = 0; i < this.listStaff.length; i++) {
            listStaff.push({
              id: this.listStaff[i].id,
              name: this.listStaff[i].name
            });
          }
          this.listStaff = listStaff;
        }
      });
  }

  getCity() {
    this.addressService.getCities().subscribe(res => {
      let citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;
    });
  }

  loadDistrictData(id: number) {
    this.addressService.getDistrict({ city_id: id }).toPromise().then(res => {
      let districts = [];
      res.data.districts.forEach((c: any) => {
        districts.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.districts = districts;
    })
  }
  public totalPages: Number;
  loadData(request: any = {}, sort: any = {}) {
    this.stores = [];
    this.loading_data = true;
    if (_.isEmpty(request)) {
      request = this.current_filter;
    }

    request.page = this.pageIndex;
    request.pageSize = this.page_size;
    delete request.desc;
    delete request.asc;
    if (Object.keys(sort).length === 0) {
      request.orderBy = "createdAt:desc"
    }
    else request.orderBy = sort.typeSort + ":" + sort.field;
    this.storeSaleService.getList(request).toPromise().then(res => {
      this.loading_data = false;
      console.log('store: ', res);
      if (res.status == 200) {
        this.stores = res.data.items;
        this.totalPages = res.data.pagination.totalPages;
        if (this.stores.length > 0) {
          this.item_detail = this.stores[this.item_active];
          this.viewDetail(this.item_active);
          if (this.item_detail.lat && this.item_detail.lon) {
            this.isShowLocation = true;
            this.zoom = 15;
            this.lat = parseFloat(this.item_detail.lat);
            this.lng = parseFloat(this.item_detail.lon);
          } else {
            this.zoom = 10;
          }
        }
        //this.setPage(this.currentPage);
      } else {
        this.message = {
          class: "alert dark alert-danger",
          content: res.status + ' : ' + res.message
        };
        this.stores = [];
        // this.genDataTable();
        this.scrollToTop();
      }
      this.total_data_store_point = res.data.pagination.totalElements;
    }, err => {
      this.message = {
        class: "alert dark alert-danger",
        content: err.message
      };
      this.stores = [];
      // this.genDataTable();
      this.scrollToTop();
    });
  }
  prePageList() {
    this.item_active = 0
    if (this.pageIndex > 1) {
      this.pageIndex = this.pageIndex - 1;
      // this.loading_left = true;
      this.loadData();
    }
  }

  lastPageList() {
    this.item_active = 0
    // console.log('res.items', this.pageIndex * this.page_size, this.total_data )
    // if (this.pageIndex * this.page_size < this.total_data) {
    this.pageIndex = this.pageIndex + 1;
    // this.loading_left = true;
    this.loadData();
    // }
  }

  inputPageList(event) {
    this.item_active = 0
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndex) {
      if (page > this.totalPages) {
        this.toastr.warning(`Số trang tối đa hiện tại là ${this.totalPages}`, "Thông báo", {
          timeOut: 3000,
          positionClass: 'toast-bottom-right'
        })
        return;
      }
      this.pageIndex = page;
      console.log("input", this.pageIndex, this.total_data_store_point);
      // this.loading_left = true;
      this.loadData();
    }

  }

  viewDetail(i) {
    this.lat = 21.0286669;
    this.lng = 105.8521485;
    this.isShowLocation = false;
    if (this.isAdd == true) {
      this.toastr.info('Thao tác tạo mới điểm bán đã bị hủy', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }
    if (this.isUpdate == true) {
      this.toastr.info('Thao tác cập nhật điểm bán đã bị hủy', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }
    this.isAdd = false;
    this.isUpdate = false;
    this.item_active = i;
    this.item_detail = this.stores[i];
    if (this.item_detail.lat && this.item_detail.lon) {
      this.isShowLocation = true;
      this.zoom = 15;
      this.lat = parseFloat(this.item_detail.lat);
      this.lng = parseFloat(this.item_detail.lon);
    } else {
      this.zoom = 10;
    }
    //console.log(this.lat, this.lng)
  }


  handleUpdated(event) {
    if (event) {
      this.loadData(this.paramsQuery);
    }
  }

  uploadExcel() {
    this.componentData = {
      component: StoreExcelComponent,
      inputs: {
        size: 'modal-md'
      }
    };
  }

  public titleFile: string = '';
  public data_import_success: { class: string; content: string; } = null;
  public data_import_fail: { class: string; content: string; } = null;
  public files: any = null;

  importStoreSaleExcel() {
    this.importStoreSale.show()
  }
  closeModalStoreSaleExcel() {
    this.importStoreSale.hide();
    this.message = null;
    this.clearInputFile();
  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }
  clearInputFile() {
    var input = $("#controlFile");
    input.wrap('<form>').closest('form').get(0).reset();
    input.unwrap();
  }

  onChange(event) {
    console.log('event', event)
    this.files = event.target.files;
    if (this.files.length > 0) {
      this.titleFile = this.files[0].name;
    } else {
      this.titleFile = this.translate.instant('PS_CHON_FILE_UPLOAD');
    }
  }
  submitFormImportExcel() {
    this.message = null;
    this.data_import_success = null;
    this.data_import_fail = null
    this.titleFile = this.translate.instant('PS_CHON_FILE_UPLOAD');
    console.log('this.files ', this.files)
    if (this.files !== null && this.files.length > 0) {
      var file = this.files[0];
      this.files = null;
      var file_name = file.name;
      var allowedExtensions = ["xlsx", "xls", "csv"];
      var fileExtension = file_name.split('.').pop();
      console.log('allowedExtensions', allowedExtensions)
      console.log('fileExtension', fileExtension)
      if (this.isInArray(allowedExtensions, fileExtension)) {
        //msg process
        this.message = {
          class: "alert dark alert-success",
          content: this.translate.instant('SS_DANG_THUC_HIEN')
        };
        //upload file
        this.storeSaleService.uploadFileProduct(file).subscribe((res: any) => {
          if (res.code === 1) {

            // this.data_import_success = {
            //   class: "alert dark alert-icon alert-success",
            //   content: 'Số sản phẩm import thành công: ' + res.data.success,
            // }

            // this.data_import_fail = {
            //   class: "alert dark alert-icon alert-warning",
            //   content: 'Số sản phẩm import không thành công: ' + res.data.fail,
            // }

            this.message = {
              class: "alert dark alert-icon alert-success",
              content: this.translate.instant('SS_IMPORT_SP_THANH_CONG'),
            };
            setTimeout(() => {
              this.pageIndex = 1;
              this.loadData();
            }, 1000);
          } else {
            this.message = {
              class: "alert dark alert-icon alert-danger",
              content: res.message
            }
              ;
          }
        }, error => {
          this.message = {
            class: "alert dark alert-icon alert-danger",
            content: error.message
          };
        });
      } else {
        this.message = {
          class: "alert alert-danger",
          content: this.translate.instant('VUI_LONG_CHON_DUNG_FILE_EXCEL')
        };
      }
    } else {
      this.message = {
        class: "alert alert-danger",
        content: this.translate.instant('BAN_CHUA_CHON_FILE_DE_IMPORT')
      };
    }
    this.clearInputFile()
  }

  resetForm(frm: NgForm) {
    $('#province').val('').trigger('change');
    $('#district').val('').trigger('change');
    $('#staff').val('').trigger('change');
    $('#status').val('').trigger('change');
    this.districts = [];
    this.pageIndex = 1;
    frm.reset();
    this.onSubmit();
  }

  onSubmit() {
    this.item_active = 0;
    let modelQuery = <any>{};
    if (this.model.name) {
      modelQuery.name = this.model.name;
    }
    if ($('#province').val()) {
      let city = $("#province option:selected").val();
      modelQuery.province = city.trim();
    }
    if ($('#district').val()) {
      let district = $('#district option:selected').val();
      modelQuery.district = district.trim();
    }
    if ($('#staff').val()) {
      let staff = $('#staff option:selected').val();
      modelQuery.created_id = staff.trim();
    }
    if (this.model.created_time) {
      // modelQuery.from = moment(this.model.created_time[0]).startOf('day')["_d"];
      // modelQuery.to = moment(this.model.created_time[1]).endOf('day')["_d"];
      modelQuery.from = moment(this.model.created_time[0]).format('DD-MM-YYYY');
      modelQuery.to = moment(this.model.created_time[1]).format('DD-MM-YYYY');
    }
    let status_value = $('#status').val();
    if (status_value) {
      modelQuery.status = status_value;
    }
    modelQuery.orderBy = 'createdAt:desc';
    this.pageIndex = 1;
    this.current_filter = modelQuery;
    this.loadData(modelQuery)
  }

  delete(id) {
    this.confirmationService.confirm({
      message: this.translate.instant('BAN_CHAC_CHAN_MUON_XOA_KHONG'),
      header: this.translate.instant('XAC_NHAN'),
      icon: 'fa fa-trash',
      accept: () => {
        this.storeSaleService.deleteSoreSale(id).subscribe(res => {
          if (res) {
            if (res.code === 1) {
              this.toastr.success(this.translate.instant('XOA_THANH_CONG'), '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
              });
            } else {
              this.toastr.error(res.message, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
              });
            }
            this.loadData(this.paramsQuery);
          }
        });
      }
    });
  }


  checkAll() {
    if ($('#td-checkbox-main').is(':checked')) {
      $('input.td-checkbox').prop('checked', true);
    } else {
      $('input.td-checkbox').prop('checked', false);
    }
  }

  rowIndex(i: number) {
    if (this.currentPage == 1) {
      return i + 1;
    } else {
      return (this.page_size) * (this.currentPage - 1) + (i + 1);//currentPage start from: 0
    }
  }

  scrollToTop() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  }

  redirectUpdate() {
    //this.router.navigate(['/evs/store-edit/' + this.item_detail.id])
    this.isAdd = false;
    this.isUpdate = true;
  }

  setSort(field: string, typeSort: string) {
    console.log("sort", field, typeSort);
    this.pageIndex = 1;
    if (this.isSorting['field'] !== field || this.isSorting['typeSort'] !== typeSort) {
      this.isSorting['field'] = field;
      this.isSorting['typeSort'] = typeSort;
      this.loadData(null, { field: field, typeSort: typeSort });
    }
  }

  addStore() {
    this.isAdd = true;
    this.isUpdate = false;
  }

  backToComponent(event) {
    this.isAdd = false;
    this.isUpdate = false;
    if (event.isBack == false) {
      this.pageIndex = 1;
      this.loadData(null, this.isSorting);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  downloadExcel() {
    let modelQuery = <any>{};
    if (this.model.name) {
      modelQuery.name = this.model.name;
    }
    if ($('#province').val()) {
      let city = $("#province option:selected").text();
      modelQuery.province = city.trim();
    }
    if ($('#district').val()) {
      let district = $('#district option:selected').text();
      modelQuery.district = district.trim();
    }

    let status_value = $('#status').val();
    if (status_value) {
      modelQuery.status = status_value;
    }
    if ($('#staff').val()) {
      let staff = $('#staff option:selected').val();
      modelQuery.created_id = staff.trim();
    }
    if (this.model.created_time) {
      modelQuery.from = moment(this.model.created_time[0]).startOf('day')["_d"];
      modelQuery.to = moment(this.model.created_time[1]).endOf('day')["_d"];
    }
    let url = environment.api_evs + '/g_store/excel?';
    if (modelQuery.name)
      url += 'name=' + modelQuery.name;
    if (modelQuery.type)
      url += 'type=' + modelQuery.type;
    if (modelQuery.province)
      url += '&province=' + modelQuery.province;
    if (modelQuery.district)
      url += '&district=' + modelQuery.district;
    if (modelQuery.status)
      url += '&status=' + modelQuery.status;
    if (modelQuery.created_id)
      url += '&created_id=' + modelQuery.created_id;
    if (modelQuery.from)
      url += '&from=' + modelQuery.from;
    if (modelQuery.to)
      url += '&to=' + modelQuery.to;
    url += '&deleted=0';
    url += '&' + this.isSorting.typeSort + '=' + this.isSorting.field;
    if (localStorage.getItem('Access-Token')) {
      url += '&Access_Token=' + localStorage.getItem('Access-Token');
    }
    location.href = url
  }

  filterClick(type, filterForm: NgForm) {
    switch (type) {
      case 'total': {
        this.resetForm(filterForm);
        break;
      }
      case 'total_show': {
        let status = $('#status');
        status.val('').trigger('change');
        filterForm.reset();
        status.val(1).trigger('change');
        this.onSubmit();
        break;
      }
      case 'total_hidden': {
        let status = $('#status');
        status.val('').trigger('change');
        filterForm.reset();
        status.val(0).trigger('change');
        this.onSubmit();
        break;
      }
    }
  }

  productAssignment() {
    this.modalAddProduct.showModal();

  }
  reload($event) {
    // this.loadData();
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/store_manager/store-sale/store-sale.component.ts